const headers = [
  {
    text: 'sale.sale_status',
    value: 'invisibleFlg',
    sortable: false,
    width: '8%',
    align: 'center'
  },
  {
    text: 'jd.jd_jdcom-product-number',
    value: 'exProductNumber',
    sortable: false,
    width: '11%',
    align: 'center'
  },
  {
    text: 'jd.jd_jdcom-sku-id',
    value: 'sku',
    sortable: false,
    width: '9%',
    align: 'center'
  },
  {
    text: 'jd.jd_delivery-request-product-name',
    value: 'name',
    sortable: false,
    width: '18%'
  },
  {
    text: 'common.product_product-name',
    value: 'jdRelatedProductName',
    sortable: false,
    width: '20%',
    rowspan: false
  },
  {
    text: 'product.product_supplier',
    value: 'jdRelatedProductSupplier',
    sortable: false,
    width: '13%',
    rowspan: false
  },
  {
    text: 'product.product_registration-quantity',
    value: 'jdRelatedProductQuantity',
    sortable: false,
    width: '7%',
    rowspan: false
  },
  {
    text: 'jd.jd_jdcom-related-product-price',
    value: 'jdRelatedProductPrice',
    sortable: false,
    width: '8%',
    rowspan: false
  },
  {
    text: 'payment.payment_operation',
    value: 'edit',
    sortable: false,
    width: '6%',
    align: 'center'
  }
]
export default { headers }
